import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../locale/en/translation.json";
import translationHN from "../locale/hn/translation.json";
import translationMR from "../locale/mr/translation.json";
import translationTL from "../locale/ta/translation.json";
import translationKO from "../locale/ko/translation.json";
import translationZH from "../locale/zh/translation.json";
import translationVI from "../locale/vi/translation.json";
import translationID from "../locale/id/translation.json";
import translationES from "../locale/es/translation.json";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: translationEN
            },
            hn: {
                translation: translationHN
            },
            mr: {
                translation: translationMR
            },
            ta: {
                translation: translationTL
            },
            ko: {
                translation: translationKO
            },
            zh: {
                translation: translationZH
            },
            vi: {
                translation: translationVI
            },
            id: {
                translation: translationID
            },
            es: {
                translation: translationES
            },
        },
        lng: "en",
        fallbackLng: "en", // keys missing in a language show English instead of the raw key
        // debug: true,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n